"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _phrase = _interopRequireDefault(require("../../../libs/translationsUtils/phrase"));

var _IdeationListItem = _interopRequireDefault(require("./IdeationListItem"));

var IdeationFiltersBox = function IdeationFiltersBox(_ref) {
  var className = _ref.className,
      selectedName = _ref.selectedName,
      onSelect = _ref.onSelect,
      ideationStatuses = _ref.ideationStatuses;
  return (0, _preact.h)("div", {
    className: className
  }, (0, _preact.h)("h3", {
    className: "widget-title"
  }, (0, _preact.h)(_phrase.default, {
    p: "filter.by.idea.status"
  })), (0, _preact.h)("ul", {
    className: "ideation-filters__idea-status"
  }, (0, _preact.h)(_IdeationListItem.default, {
    selectedName: selectedName,
    name: null,
    onSelect: onSelect
  }), ideationStatuses.map(function (_ref2, index) {
    var name = _ref2.name;
    return (0, _preact.h)(_IdeationListItem.default, {
      key: index,
      selectedName: selectedName,
      name: name,
      onSelect: onSelect
    });
  })));
};

var _default = IdeationFiltersBox;
exports.default = _default;